import { useEffect, useState } from "react";
import {
  getOnlyCrews,
  getReviewTimeSheetsList,
  getUserDetails,
  updateMyTimeCardStatus,
} from "../API";
import reloadIcon from "../assets/images/reload2.png";
import { toast } from "react-toastify";
import Loader from "./Loader";
import RecallWarningModal from "../components/modal/RecallWarningModal";
import { useNavigate } from "react-router-dom";
import DateRangePicker from "../components/common/DateRangePicker";
import { useSelector } from "react-redux";
import { dateRangeValue } from "../redux/selectors/timeSheetDateRangeSelector";
import { formatToWeekYear } from "../utils/utils";
import TickIcon from "../assets/images/correct.png";
import WarningModal from "../components/common/WarningModal";
import { Tooltip } from "react-tooltip";
import ProcessTimeSheetFilter from "../components/ProcessTimeSheetFilter";
import ActionCompleteConfirmationModal from "../components/modal/actionCompleteConfirmationModal";

const ProcessTimeSheet = () => {
  const [selectedUserSheets, setSelectedUserSheets] = useState([]);
  const [selectedRetryTimesheet, setSelectedRetryTimesheet] = useState({
    name: "",
    time_sheet_id: "",
  });
  const [selectedEquipmentSheet, setSelectedEquipmentSheet] = useState([]);
  const [inReviewTeamHours, setInReviewTeamHours] = useState([]);
  const [inReviewEquipmentHours, setInReviewEquipmentHours] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTimeSheet, setSelectedTimeSheet] = useState();
  const [userOptions, setUserOptions] = useState([]);
  const [allCrews, setAllCrews] = useState([]);
  const [filterFields, setFilterFields] = useState({
    foreman_name: "",
    crew_id: "",
    employee_process_status_id: "",
    equipment_process_status_id: "",
  });

  const navigate = useNavigate();

  const constructQueryString = (state) => {

    const filterFields = {
      foreman_name: state.foreman_name,
      crew_id: state.crew_id.id,
      employee_process_status_id: state.employee_process_status_id.id,
      equipment_process_status_id: state.equipment_process_status_id.id,
    };

    const queryParams = Object.entries(filterFields)
      .filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
      .map(([key, value]) => {  
        return `${key}=${encodeURIComponent(value)}`;
      })
      .join("&");

    return queryParams;
  };

  const role = localStorage.getItem("role_name");
  const weekDate = useSelector(dateRangeValue);
  const weekRangeFilter = weekDate?.endDate
    ? `week_start=${formatToWeekYear(
        weekDate?.startDate,
        "-"
      )}&week_end=${formatToWeekYear(weekDate?.endDate, "-")}`
    : "";

  const getAllInProcessTimeSheets = async () => {
    setIsLoading(true);
    if (role === "Admin") {
      const query =
        weekRangeFilter !== ""
          ? `time_sheet_status_ids=${4}&${weekRangeFilter}`
          : `time_sheet_status_ids=${4}`;

      const queryFilter = constructQueryString(filterFields);

      await getReviewTimeSheetsList(`${query}&${queryFilter}`).then(
        async (res) => {
          if (res?.status === 200) {
            const filteredTeamHours = res?.data?.filter(
              (data) => data?.time_entry_type_id === 1
            );
            const filteredEquipmentHours = res?.data?.filter(
              (data) => data?.time_entry_type_id === 2
            );
            setInReviewTeamHours(filteredTeamHours);
            setInReviewEquipmentHours(filteredEquipmentHours);
            setIsLoading(false);
          }
        }
      );
    }
  };

  const getUserOptions = async () => {
    await getUserDetails().then((res) => {
      const optionsArr = res?.data?.map((ele) => {
        return {
          label: ele?.name,
          value: ele?.name,
        };
      });
      setUserOptions(optionsArr);
    });
    const data = { query: "is_active=true" };
    getOnlyCrews(data).then((res) => {
      setAllCrews(res?.data);
    });
  };

  useEffect(() => {
    getAllInProcessTimeSheets();
  }, [weekDate.endDate, filterFields]);

  useEffect(() => {
    getUserOptions();
  }, []);

  const onClickProcess = async (e, item) => {
    const name = e.target.name;
    let payload;
    if (name === "user") {
      payload = {
        employee_process_status_id: 1,
      };
      await updateMyTimeCardStatus(payload, item?.time_sheet_id).then((res) => {
        if (res?.status === 200) {
          getAllInProcessTimeSheets();
          toast.success("User timesheet status updated");
        }
      });
    } else if (name === "equipment") {
      payload = {
        equipment_process_status_id: 1,
      };
      await updateMyTimeCardStatus(payload, item?.time_sheet_id).then((res) => {
        if (res?.status === 200) {
          getAllInProcessTimeSheets();
          toast.success("Equipment timesheet status updated");
        }
      });
    }
  };

  const onClickRetry = async () => {
    const name = selectedRetryTimesheet.name
    let payload;
    if (name === "user") {
      payload = {
        employee_process_status_id: 1,
      };
      await updateMyTimeCardStatus(payload, selectedRetryTimesheet?.time_sheet_id).then((res) => {
        if (res?.status === 200) {
          getAllInProcessTimeSheets();
          toast.success("User timesheet status updated");
          setSelectedRetryTimesheet({
            name: "",
            time_sheet_id: "",
          });
        }
      });
    } else if (name === "equipment") {
      payload = {
        equipment_process_status_id: 1,
      };
      await updateMyTimeCardStatus(payload, selectedRetryTimesheet?.time_sheet_id).then((res) => {
        if (res?.status === 200) {
          getAllInProcessTimeSheets();
          toast.success("Equipment timesheet status updated");
          setSelectedRetryTimesheet({
            name: "",
            time_sheet_id: "",
          });
        }
      });
    }
  };

  const onSelectCheckbox = (e) => {
    const { name, checked } = e.target;
    if (name === "User") {
      if (checked) {
        const filterTimeSheets = inReviewTeamHours?.filter(
          (item) => item.employee_process_status_id === 0
        );
        setSelectedUserSheets([...filterTimeSheets]);
      } else {
        setSelectedUserSheets([]);
      }
    } else if (name === "Equipment") {
      if (checked) {
        const filterTimeSheets = inReviewEquipmentHours?.filter(
          (item) => item.equipment_process_status_id === 0
        );
        setSelectedEquipmentSheet([...filterTimeSheets]);
      } else {
        setSelectedEquipmentSheet([]);
      }
    }
  };

  const handleUserTimeSheet = (e, item) => {
    const { checked, name } = e.target;
    if (name === "User") {
      if (checked) {
        setSelectedUserSheets((prevSheets) => [...prevSheets, item]);
      } else {
        setSelectedUserSheets((prevSheets) =>
          prevSheets.filter((ele) => ele.time_sheet_id !== item.time_sheet_id)
        );
      }
    } else if (name === "Equipment") {
      if (checked) {
        setSelectedEquipmentSheet((prevSheets) => [...prevSheets, item]);
      } else {
        setSelectedEquipmentSheet((prevSheets) =>
          prevSheets.filter((ele) => ele.time_sheet_id !== item.time_sheet_id)
        );
      }
    }
  };

  const isSelected = (item) => {
    const itemSelected = selectedUserSheets?.some(
      (ele) => ele?.time_sheet_id === item?.time_sheet_id
    );
    return itemSelected;
  };

  const isEquipmentSelected = (item) => {
    const itemSelected = selectedEquipmentSheet?.some(
      (ele) => ele?.time_sheet_id === item?.time_sheet_id
    );
    return itemSelected;
  };

  const onClickSubmit = async (item) => {
    if (item === "User") {
      const processTimeSheetRes = selectedUserSheets?.map((ele) => {
        const payload = {
          employee_process_status_id: 1,
        };
        return updateMyTimeCardStatus(payload, ele?.time_sheet_id);
      });
      await Promise.all(processTimeSheetRes);
      getAllInProcessTimeSheets();
      toast.success("All user time sheet processed");
      setSelectedUserSheets([]);
    } else if (item === "Equipment") {
      const processTimeSheetRes = selectedEquipmentSheet?.map((ele) => {
        const payload = {
          equipment_process_status_id: 1,
        };
        return updateMyTimeCardStatus(payload, ele?.time_sheet_id);
      });
      await Promise.all(processTimeSheetRes);
      getAllInProcessTimeSheets();
      toast.success("All equipment time sheet processed");
      setSelectedEquipmentSheet([]);
    }
  };

  const isEquipmentDisabled = (teamHours) => {
    const isEquipmentDisabled = inReviewEquipmentHours?.some(
      (ele) =>
        ele?.crew_id === teamHours?.crew_id && ele?.week === teamHours?.week
    );
    return isEquipmentDisabled;
  };

  const onClickReturn = async (card) => {
    await updateMyTimeCardStatus(
      {
        time_sheet_status_id: 1,
      },
      card?.time_sheet_id
    ).then((res) => {
      if (res?.status === 200) {
        toast.success("Time Sheet Status Updated");
        navigate("/time-sheet");
      }
    });
  };

  const onClickWarningModal = async () => {
    let payload;
    if (selectedTimeSheet?.time_entry_type === "user") {
      payload = {
        employee_process_status_id: 5,
      };
      await updateMyTimeCardStatus(
        payload,
        selectedTimeSheet?.time_sheet_id
      ).then((res) => {
        if (res?.status === 200) {
          getAllInProcessTimeSheets();
          toast.success("User timesheet status updated");
        }
      });
    } else if (selectedTimeSheet?.time_entry_type === "equipment") {
      payload = {
        equipment_process_status_id: 5,
      };
      await updateMyTimeCardStatus(
        payload,
        selectedTimeSheet?.time_sheet_id
      ).then((res) => {
        if (res?.status === 200) {
          getAllInProcessTimeSheets();
          toast.success("Equipment timesheet status updated");
        }
      });
    }
  };

  return (
    <div>
      <>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="timesheet"
        >
          <h3 className="title" style={{ fontWeight: "600" }}>
            Process Timesheets
          </h3>
          <div
            className="custom-date-picker-wrapper d-flex"
            style={{ position: "relative" }}
          >
            <DateRangePicker />
            <ProcessTimeSheetFilter
              userOptions={userOptions}
              allCrews={allCrews}
              filterFields={filterFields}
              setFilterFields={setFilterFields}
            />
          </div>
        </div>
        <div className="timesheet-data process-timesheet-page">
          {!isLoading ? (
            <div className="table-responsive crew-table all-crew-table data-table-shell process-timesheet-shell">
              <table className="table table-striped tableV2 process-timesheets">
                <thead>
                  <tr>
                    {[
                      "Crew Id",
                      "Foreman",
                      "Week",
                      "User",
                      "Equipment",
                      "Action",
                    ]?.map((item, key) => {
                      if (item === "User" || item === "Equipment") {
                        const processUser = inReviewTeamHours?.some(
                          (ele) => ele?.employee_process_status_id === 0
                        );
                        const processEquipment = inReviewEquipmentHours?.some(
                          (ele) => ele?.equipment_process_status_id === 0
                        );

                        return (
                          <th
                            scope="col"
                            className="table-heading header"
                            key={key}
                          >
                            <div className="d-flex align-items-center process-btns">
                              {processUser && item === "User" && (
                                <input
                                  name={item}
                                  style={{ cursor: "pointer" }}
                                  type="checkbox"
                                  className="me-3"
                                  onChange={(e) => onSelectCheckbox(e)}
                                  checked={
                                    item === "User"
                                      ? selectedUserSheets?.length > 0
                                      : selectedEquipmentSheet?.length > 0
                                  }
                                />
                              )}
                              {processEquipment && item === "Equipment" && (
                                <input
                                  name={item}
                                  style={{ cursor: "pointer" }}
                                  type="checkbox"
                                  className="me-3"
                                  onChange={(e) => onSelectCheckbox(e)}
                                  checked={
                                    item === "User"
                                      ? selectedUserSheets?.length > 0
                                      : selectedEquipmentSheet?.length > 0
                                  }
                                />
                              )}
                              {item}
                              {item === "User" &&
                                selectedUserSheets?.length > 0 && (
                                  <button
                                    type="button"
                                    className="p-2 primary-btn ms-1"
                                    onClick={() => onClickSubmit(item)}
                                  >
                                    Submit
                                  </button>
                                )}
                              {item === "Equipment" &&
                                selectedEquipmentSheet?.length > 0 && (
                                  <button
                                    type="button"
                                    className="p-2 primary-btn ms-1"
                                    onClick={() => onClickSubmit(item)}
                                  >
                                    Submit
                                  </button>
                                )}
                            </div>
                          </th>
                        );
                      }

                      return (
                        <th
                          scope="col"
                          className="table-heading data"
                          key={key}
                        >
                          {item}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {inReviewTeamHours?.length > 0 ? (
                    inReviewTeamHours?.map((teamItem, key) => (
                      <tr key={key}>
                        <td className="crew-id">
                          <div>{teamItem?.virtual_crew_id || "NA"}</div>
                        </td>
                        <td className="fm-name">{teamItem?.foreman_name}</td>
                        <td className="week">
                          <div>{teamItem?.week}</div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center process-btns">
                            {teamItem?.employee_process_status_id === 0 &&
                              teamItem?.time_entry_type_id === 1 && (
                                <>
                                  <input
                                    name="User"
                                    style={{ cursor: "pointer" }}
                                    className="me-3"
                                    type="checkbox"
                                    checked={isSelected(teamItem)}
                                    onChange={(e) =>
                                      handleUserTimeSheet(e, teamItem)
                                    }
                                  />
                                  <button
                                    name="user"
                                    type="button"
                                    className="primary-btn submit-btn"
                                    onClick={(e) => onClickProcess(e, teamItem)}
                                  >
                                    Process
                                  </button>
                                </>
                              )}
                            {(teamItem?.employee_process_status_id === 1 ||
                              teamItem?.employee_process_status_id === 2 ||
                              teamItem?.employee_process_status_id === 3) && (
                              <>
                                <button
                                  disabled={true}
                                  name="user"
                                  type="button"
                                  className="primary-btn submit-btn processing"
                                  onClick={(e) => onClickProcess(e, teamItem)}
                                >
                                  Processing
                                </button>
                              </>
                            )}
                            {teamItem?.employee_process_status_id === 4 && (
                              <>
                                <button
                                  name="user"
                                  type="button"
                                  className={
                                    teamItem?.employee_process_status_id === 4
                                      ? "primary-btn submit-btn retry-btn processing"
                                      : ""
                                  }
                                  onClick={(e) => onClickProcess(e, teamItem)}
                                >
                                  Retry
                                </button>
                                <img
                                  onClick={() =>
                                    setSelectedTimeSheet({
                                      ...teamItem,
                                      time_entry_type: "user",
                                    })
                                  }
                                  data-bs-toggle="modal"
                                  data-bs-target="#warningModal"
                                  className="correct-logo ms-2"
                                  src={TickIcon}
                                  alt=""
                                  data-tooltip-id="warning-tooltip"
                                  data-tooltip-content="Change the time entry status manually"
                                />
                                <Tooltip
                                  id="warning-tooltip"
                                  place="top"
                                  effect="solid"
                                />
                              </>
                            )}
                            {teamItem?.employee_process_status_id === 5 && (
                              <>
                              <button
                                disabled={true}
                                name="user"
                                type="button"
                                className={
                                  teamItem?.employee_process_status_id === 5
                                    ? "primary-btn submit-btn processed-btn"
                                    : ""
                                }
                                onClick={(e) => onClickProcess(e, teamItem)}
                              >
                                Processed
                              </button>
                                <img
                                  name="user"
                                  onClick={(e) =>
                                    setSelectedRetryTimesheet({
                                      name: e.target.name,
                                      time_sheet_id: teamItem.time_sheet_id,
                                    })
                                  }
                                  data-bs-toggle="modal"
                                  data-bs-target="#actionCompleteConfirmationModal"
                                  className="correct-logo ms-2"
                                  src={reloadIcon}
                                  alt=""
                                  data-tooltip-id="retry-tooltip"
                                  data-tooltip-content="You can retry to process this entry"
                                />
                                <Tooltip
                                  id="retry-tooltip"
                                  place="top"
                                  effect="solid"
                                />
                              </>
                            )}
                          </div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center process-btns">
                            {teamItem?.equipment_process_status_id === 0 && (
                              <>
                                {isEquipmentDisabled(teamItem) && (
                                  <input
                                    name="Equipment"
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    className="me-3"
                                    checked={isEquipmentSelected(teamItem)}
                                    onChange={(e) =>
                                      handleUserTimeSheet(e, teamItem)
                                    }
                                  />
                                )}
                                <button
                                  disabled={!isEquipmentDisabled(teamItem)}
                                  name="equipment"
                                  type="button"
                                  className="primary-btn submit-btn"
                                  onClick={(e) => onClickProcess(e, teamItem)}
                                >
                                  {isEquipmentDisabled(teamItem)
                                    ? "Process"
                                    : "NA"}
                                </button>
                              </>
                            )}
                            {(teamItem?.equipment_process_status_id === 1 ||
                              teamItem?.equipment_process_status_id === 2 ||
                              teamItem?.equipment_process_status_id === 3) && (
                              <>
                                <button
                                  disabled={true}
                                  name="equipment"
                                  type="button"
                                  className="primary-btn submit-btn processing"
                                  onClick={(e) => onClickProcess(e, teamItem)}
                                >
                                  Processing
                                </button>
                              </>
                            )}
                            {teamItem?.equipment_process_status_id === 4 && (
                              <>
                                <button
                                  name="equipment"
                                  type="button"
                                  className={
                                    teamItem?.equipment_process_status_id === 4
                                      ? "primary-btn submit-btn retry-btn processing"
                                      : ""
                                  }
                                  onClick={(e) => onClickProcess(e, teamItem)}
                                >
                                  Retry
                                </button>
                                <img
                                  onClick={() =>
                                    setSelectedTimeSheet({
                                      ...teamItem,
                                      time_entry_type: "equipment",
                                    })
                                  }
                                  data-bs-toggle="modal"
                                  data-bs-target="#warningModal"
                                  className="correct-logo ms-2"
                                  src={TickIcon}
                                  alt=""
                                  data-tooltip-id="warning-tooltip"
                                  data-tooltip-content="Change the time entry status manually"
                                />
                                <Tooltip
                                  id="warning-tooltip"
                                  place="top"
                                  effect="solid"
                                />
                              </>
                            )}
                            {teamItem?.equipment_process_status_id === 5 && (
                              <button
                                disabled={true}
                                name="equipment"
                                type="button"
                                className={
                                  teamItem?.equipment_process_status_id === 5
                                    ? "primary-btn submit-btn processed-btn"
                                    : ""
                                }
                                onClick={(e) => onClickProcess(e, teamItem)}
                              >
                                Processed
                              </button>
                            )}
                          </div>
                        </td>
                        <td
                          className="details-td table-actions"
                          style={{ minWidth: "150px", textAlign: "center" }}
                        >
                          <button
                            data-bs-toggle="modal"
                            data-bs-target="#recallWarningModal"
                            onClick={() => setSelectedTimeSheet(teamItem)}
                            outline
                            className="open recall-btn"
                          >
                            Recall{" "}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                            >
                              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                              <path d="M3 3v5h5" />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </>
      <RecallWarningModal
        onClickReturn={onClickReturn}
        selectedTimeSheet={selectedTimeSheet}
      />
      <ActionCompleteConfirmationModal 
        onClickYes={onClickRetry}
        confirmationText="Are you sure you want to retry this time entry?"
      />
      <WarningModal
        modalId="warningModal"
        text="Are you sure you want to move this time entry to processed?"
        selectedValue={selectedTimeSheet}
        onClickOk={onClickWarningModal}
        onClickCancel={() => setSelectedTimeSheet({})}
      />
    </div>
  );
};

export default ProcessTimeSheet;
